export const GMAPS_NOT_NEEDED = 'GMAPS_NOT_NEEDED';
export const GMAPS_ALREADY_LOADED = 'GMAPS_ALREADY_LOADED';
export const GMAPS_LOAD_SUCCESS = 'GMAPS_LOAD_SUCCESS';

export function maybeLoadGmaps(args) {
  const jQuery = args.jQuery;
  if (window.google && window.google.maps && window.google.maps.Places) {
    // we already have gmaps
    return Promise.resolve({ reason: GMAPS_ALREADY_LOADED });
  }

  const CARROT_GMAPS_Q = 'CARROT_GMAPS_Q';

  // we need gmaps
  return new Promise(function (resolve, reject) {
    if (window.CARROT_LOADING_GMAPS) {
      if (!window[CARROT_GMAPS_Q]) {
        window[CARROT_GMAPS_Q] = [];
      }

      window[CARROT_GMAPS_Q].push(function (res) {
        const success = res.success;
        return success ? resolve({ reason: GMAPS_LOAD_SUCCESS }) : reject();
      });

      return;
    }

    window.CARROT_LOADING_GMAPS = true;
    const CARROT_GMAPS_CALLBACK = 'CARROT_GMAPS_CALLBACK';
    window[CARROT_GMAPS_CALLBACK] = function () {
      resolve({ reason: GMAPS_LOAD_SUCCESS });
      if (!window[CARROT_GMAPS_Q]) {
        return;
      }
      while (window[CARROT_GMAPS_Q].length > 0) {
        const callback = window[CARROT_GMAPS_Q].shift();
        callback({ success: true });
      }
    };

    const gmapsScript = '//maps.googleapis.com/maps/api/js';
    const gmapsOptions = {
      key: window.GOOGLE_MAPS_ROTATING_KEY,
      libraries: 'places',
      loading: 'async',
      callback: CARROT_GMAPS_CALLBACK,
    };

    jQuery.get(gmapsScript, gmapsOptions, null, 'script').fail(function () {
      window.CARROT_LOADING_GMAPS = false;
      reject();
      while (window[CARROT_GMAPS_Q].length > 0) {
        const callback = window[CARROT_GMAPS_Q].shift();
        callback({ success: false });
      }
    });
  });
}
